import React from 'react';

import styles from 'global/styles/404.module.scss';

const ErrorPage = () => {
  return (
    <div className={`${'container'} ${styles.errorPageWrapper}`}>
      <h1>Произошла ошибка.</h1>
      <span>Страницы с таким адресом не существует.</span>
    </div>
  );
};

export default ErrorPage;
